export const startScheduleCycle = () => {
  document.addEventListener("DOMContentLoaded", startEasyScheduleAndRemoveEventListener);
};

const startEasyScheduleAndRemoveEventListener = () => {
  window.EASY.schedule.startCycle();
  document.removeEventListener("DOMContentLoaded", startEasyScheduleAndRemoveEventListener);
};
